import { DEFAULT_USER } from "@/shared/components/MessageRecipients/constants/RecipientsConstants";
import { FieldChannels } from "../components/NotificationModal/model/FieldChannels";
import { RecipientsConfiguration } from "../models/MessageRecipients";
import { Notification } from "../models/Notification";
import { NotificationConfig } from "../models/NotificationConfig";

export const NOTIFICATION_MESSAGES = {
  ERROR_MESSAGE:
    "Ha ocurrido un error, es posible que no recibas notificaciones en tu dispositivo",
  REJECT_MESSAGE: "No recibirás notificaciones en tu dispositivo",
  ERROR_DELETING: "Ocurrió un error eliminando la notificación",
  ERROR_GETTING: "Ocurrió un error obteniendo las notificaciones",
  ERROR: "Ocurrió un error desvinculando la suscripción. Intente más tarde",
  ERROR_SUBSCRIBE:
    "Ocurrió un error, verifique que la recepción de notificaciones se encuentra habilitado en tú navegador"
};

export const NOTIFICATION_PERMISSIONS = {
  GRANTED: "granted",
  DENIED: "denied",
  DEFAULT: "default"
};

export const NOTIFICATION_EVENTS = {
  ACCEPT: "acceptNotification",
  EDITED: "editedNotification",
  CANCEL: "cancelNotification",
  DOCUMENT: {
    FILES_CHOSEN: "filesChosen",
    CLOSE_MODAL: "closeDocumentModal",
    ADD: "addDocument",
    DELETE: "deleteDocument"
  },
  GET_NOTIFICATIONS: "eventGetNotifications",
  UPDATE: {
    NAME: "updateName",
    CHANNELS: "updateChannels",
    MESSAGE_TYPE: "updateMessageType",
    MESSAGE_CATEGORY: "updateMessageCategory",
    TIME: "updateTime",
    DATE: "updateDate",
    FREQUENCY: "updateFrequency",
    TIMES: "updateTimes",
    TITLE: "updateTitle",
    URL: "updateUrl",
    TEMPLATE: "updateTemplate",
    PARAMS: "updateParams"
  },
  VALID_DOC_DATA: "validDocumentData",
  SAVE: "saveNotification",
  MAPPED: {
    INITIAL_CONFIGURATION: "initialConfigMapped",
    MESSAGE_CONFIGURATION: "messageConfigMapped"
  },
  UPDATE_INMEDIATE: "updateInmediate",
  REMINDER: "reminder",
  VALIDATE_FREE_WHATSAPP: "validateWhatsApp"
};

const CHANNEL_TEXT = {
  WHATSAPP: "whatsapp",
  SMS: "sms",
  PUSH: "push",
  EMAIL: "email",
  WEBHOOK: "webhook"
};

export const NOTIFICATION_CONFIG = {
  TITLE: "Configuración de Notificación",
  SELECT_CHANNEL: "Seleccione un canal",
  CHANNEL_TEXT,
  MSG_TYPES_TEXT: {
    TEXT: "TEXT",
    IMAGE: "IMAGE",
    VIDEO: "VIDEO",
    FILE: "DOCUMENT",
    LOCATION: "LOCATION"
  },
  MSG_TYPES: [
    { name: "Texto", value: "TEXT" },
    { name: "Imagen", value: "IMAGE" },
    { name: "Video", value: "VIDEO" },
    { name: "Documento", value: "DOCUMENT" },
    { name: "Ubicación", value: "LOCATION" }
  ],
  MSG_CATEGORIES: [
    { name: "Cita", value: "CITAS" },
    { name: "Clínica", value: "CLÍNICA" },
    { name: "Consultorio", value: "CONSULTORIO" },
    { name: "Nueva", value: "NEW" }
  ],
  CHANNELS: [
    { name: "Whatsapp", value: CHANNEL_TEXT.WHATSAPP },
    { name: "Sms", value: CHANNEL_TEXT.SMS },
    { name: "Push", value: CHANNEL_TEXT.PUSH },
    { name: "Email", value: CHANNEL_TEXT.EMAIL },
    { name: "Webhook", value: CHANNEL_TEXT.WEBHOOK }
  ],
  USER_FILTERS: ["Nombre", "Teléfono", "Identificación"],
  REGEX_BODY: /\{\{\d+\}\}/g,
  SERVICE_PARAMS: [
    {
      name: "Nombre interno servicio",
      id: "internalName",
      editable: false
    },
    {
      name: "Estado servicio",
      id: "state",
      editable: false
    },
    {
      name: "Categoría de servicio",
      id: "category",
      editable: false
    },
    {
      name: "Progreso de servicio",
      id: "progress",
      editable: false
    }
  ],
  ORDER_PARAMS: [
    {
      name: "Número de orden médica",
      id: "nroMedicalOrder",
      editable: false
    },
    {
      name: "Nivel de precio",
      id: "cups",
      editable: false
    },
    {
      name: "Tipo de facturación",
      id: "billType",
      editable: false
    },
    {
      name: "Estado de orden",
      id: "state",
      editable: false
    },
    {
      name: "Sede",
      id: "campus",
      editable: false
    },
    {
      name: "Pago",
      id: "payment",
      editable: false
    }
  ],
  MEDICAL_APPOINTMENT_PARAMS: [
    {
      name: "Estado de la cita",
      id: "state",
      editable: false
    },
    {
      name: "Fecha y hora de cita",
      id: "name",
      editable: false
    },
    {
      name: "Servicio",
      id: "service",
      editable: false
    }
  ],
  TASK_PARAMS: [
    {
      name: "Estado de la tarea",
      id: "state",
      editable: false
    }
  ],
  SESSION_PARAMS: [
    {
      name: "Estado de la sessión",
      id: "state",
      editable: false
    }
  ],
  USER_PARAMS: [
    {
      name: "Estado del usuario",
      id: "state",
      editable: false
    }
  ],
  GENERAL_PARAMS: [
    {
      name: "Fecha de creación",
      id: "dateCreated",
      editable: false
    },
    {
      name: "Fecha de modificación",
      id: "dateChanged",
      editable: false
    },
    {
      name: "Enlace de la aplicación",
      id: "neumoUrl",
      editable: false
    }
  ],
  DOCUMENT_MESSAGE: {
    SELECTION: "Selección de documentos",
    SEARCH: "Búsqueda de documentos",
    SELECTED: "Documentos seleccionados"
  },
  RULE_TYPES: {
    TASK: "task",
    SERVICE: "service",
    ORDER: "order",
    NO_RULE: "noRule"
  },
  NOTIFICATION_NAME_EXIST: "El nombre de la notificación ya existe",
  DIALOG_MSG: {
    CLEAN: {
      TITLE: "Limpiar",
      TEXT: "¿Está seguro que desea comenzar de nuevo?"
    }
  },
  SEARCH_HINT: "Buscar",
  LABEL: {
    CREATE_NOTIFICATION: "Crear notificación",
    CREATED_NOTIFICATION: "Notificaciones creadas",
    INITIAL_CONFIG_TEXT: "Configuración inicial",
    DOC_DATA_TEXT: "Datos de documentos",
    MSG_DATA_TEXT: "Datos del mensaje",
    MSG_TEXT: "Mensaje:",
    EXAMPLE_TEXT: "Ejemplo:",
    RECEIVERS_TEXT: "Destinatarios",
    LOAD_MORE_TEXT: "Cargar mas opciones",
    SEND_DOCUMENT: "Enviar documento",
    NAME: "Nombre*",
    CHANNEL: "Canales*",
    MSG_TYPE: "Tipo de mensaje*",
    MSG_CATEGORY: "Categoria de mensaje*",
    TIME: "Hora de envío",
    START_DATE: "Envío específicamente en:*",
    FREQUENCY: "Enviar cada:*",
    TIMES: "Enviar máximo:",
    BODY: "Cuerpo del mensaje*",
    WHATSAPP_TEMPLATE: "Plantilla",
    WEBHOOK: "Webhook",
    FORM_FIELD: "Campos de formulario",
    DOCUMENT_TEMPLATE: "Plantilla de documento*",
    TASK_STATE: "Estado de la tarea*",
    TITLE: "Titulo*",
    URL: "Url Push",
    EMAIL: "Correo*",
    VIDEO: "Video*",
    IMAGE: "Imagen*",
    FILE: "Documento",
    LATITUDE: "Latitud*",
    LONGITUDE: "Longitud*",
    USER: "Buscar el usuario destinatario",
    NEW_NOTIFICATION: "Nueva Notificación",
    CLEAN_NOTIFICATION: "Limpiar configuración",
    CATEGORY: "Categoria",
    IMEDIATE_LABEL: "Programar envio de notificación",
    REMINDER_LABEL: "Enviar antes",
    BEFORE_DATE: "Enviar antes:*",
    FIELD_TEXT: "Campo ",
    SUBJECT_TEXT: "Asunto",
    CUSTOM_FIELD_TEXT: "Campo personalizado",
    LIST_FIELD_TEXT: "Seleccionar campo desde lista",
    SUBJECT_MESSAGE: "Asunto del mensaje"
  },
  HINT: {
    NAME: "Nombre de la notificación",
    CHANNEL: "Seleccione canales de envio",
    MSG_TYPE: "Tipo de mensaje a enviar",
    MSG_CATEGORY: "Categoria de mensaje a enviar",
    TASK_STATE: "Seleccione un estado",
    TIME: "Hora de envio de la notificación",
    START_DATE: "Días después de cumplirse la regla",
    FREQUENCY: "Frecuencia de envio",
    TIMES: "Cantidad de veces que se enviará la notificación",
    WHATSAPP_TEMPLATE: "Seleccione una plantilla",
    WEBHOOK: "Seleccione un webhook",
    FORM_FIELD: "Seleccione los campos del formulario",
    URL: "Digitar el enlace fuente",
    USER: "Escriba el valor a buscar del usuario y presiona enter para buscar",
    USER_TEMP: "Escriba el nombre de la plantilla y presiona enter para buscar",
    BEFORE_DATE: "Días antes de cumplirse la regla"
  },
  ERRORS: {
    INVALID_IMG_FORMAT:
      "El formato de imagen selecionado no es soportado por el canal"
  }
};

export const NOTIFICATION_STATES = {
  SENT: "Enviada"
};

export const WHATSAPP_TEMPLATE_TYPES = {
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  DOCUMENT: "DOCUMENT",
  TEXT: "TEXT"
};

export const NEUMOMED_IMAGE =
  "https://play-lh.googleusercontent.com/NgEfTWkneTOyKDDRyqGE1DGiaWvVBsaUmeo4dQarBGqWiAixe7G2WwoHaqkvSLpQM1w";

export const DOCUMENT_NOTIFICATION = {
  SENDED: "Notificación enviada correctamente",
  ERROR: "Ocurrió un error al enviar la notificación, intente más tarde"
};

export const NOTIFICATION_INIT_CL: Notification = {
  frequency: 0,
  dateScheduled: 0,
  tracing: false,
  channels: [],
  warningRate: 0,
  ruleRef: "",
  message: {
    title: "",
    body: "",
    image: { _key: "" },
    video: { _key: "" },
    file: "",
    latitude: "",
    longitude: "",
    params: [],
    phone: "",
    type: "TEXT",
    category: ""
  },
  isScheduledNotification: false
};

export const NOTIFICATION_INIT: Notification = {
  frequency: 0,
  dateScheduled: 0,
  tracing: false,
  channels: [],
  warningRate: 0,
  ruleRef: "",
  message: {
    title: "",
    body: "",
    image: { _key: "" },
    video: { _key: "" },
    file: "",
    latitude: "",
    longitude: "",
    params: [],
    phone: "",
    type: "TEXT",
    category: ""
  },
  isScheduledNotification: false
};

export const CLEAR_FIELDS_NOTIFICATION: Notification = {
  frequency: 0,
  dateScheduled: 0,
  tracing: false,
  channels: [],
  warningRate: 0,
  ruleRef: "",
  message: {
    title: "",
    body: "",
    image: { _key: "" },
    video: { _key: "" },
    file: "",
    latitude: "",
    longitude: "",
    params: [],
    phone: "",
    type: "IMAGE",
    category: ""
  },
  isScheduledNotification: false
};

export const RECIPIENTS_INIT: RecipientsConfiguration = {
  defaultRecipients: [DEFAULT_USER.param],
  dependencies: [],
  userTemplates: [],
  dependencyUsers: [],
  templateUsers: []
};

export const NOTIFICATION_CONFIG_INIT: NotificationConfig = {
  name: "",
  notification: NOTIFICATION_INIT,
  recipients: RECIPIENTS_INIT,
  startDate: null,
  type: "",
  time: ""
};

export const NOTIFICATION_CONFIG_INIT_CL: NotificationConfig = {
  name: "",
  notification: NOTIFICATION_INIT_CL,
  recipients: RECIPIENTS_INIT,
  startDate: null,
  type: "",
  time: ""
};

export const CLEAR_FIELDS_NOTIFICATION_CONFIG: NotificationConfig = {
  name: "",
  notification: CLEAR_FIELDS_NOTIFICATION,
  recipients: RECIPIENTS_INIT,
  startDate: null,
  type: "",
  time: ""
};

export const NOTIFICATION_MODAL_TYPE = {
  SEND: "sendNotification",
  SAVE: "saveNotification",
  TASK: "taskAction",
  MULTIPLE_ACTION: "multipleActionNotification"
};

export const FIELDS_INIT: FieldChannels = {
  whatsappFields: false,
  pushFields: false,
  smsFields: false,
  emailFields: false,
  webhookFields: false
};

export const MESSAGES = {
  IMMEDIATE_MESSAGE:
    "Recuerde que su notificación sera enviada de forma inmediata",
  FREQUENCY_MESSAGE:
    "Recuerde que su notificación sera enviada cada {frequency} días",
  FREQUENCY_HOUR_MESSAGE:
    "Recuerde que su notificación sera enviada a las {time} cada {frequency} días",
  SCHEDULED_FRECUENCY_HOUR_MESSAGE:
    "Recuerde que su notificación sera enviada en {startDate} dia cada {frequency} días a las {time}",
  SCHEDULED_FRECUENCY_MESSAGE:
    "Recuerde que su notificación sera enviada en {startDate} días cada {frequency} días",
  SCHEDULED_MESSAGE:
    "Recuerde que su notificación sera enviada en {startDate} días",
  SCHEDULED_HOUR_MESSAGE:
    "Recuerde que su notificación sera enviada en {startDate} días a las {time}",
  HOUR_MESSAGE: "Recuerde que su notificación sera enviada a las {time}"
};

export const NOTIFICATION_LISTS_ID = {
  CATEGORIES: "Da5g9o4DEwxNJMrAcgAE"
};

export const NOTIFICATION_ACCESS = {
  GET: "consultar notificaciones",
  POST: "crear notificaciones",
  PUT: "modificar notificaciones",
  DELETE: "eliminar notificaciones"
};

export const MULTIMEDIA_NEUMOMED_IMG = {
  _key: "nfvjv8ydhhcbfvfsxsz",
  category: "Informativos",
  fieldName: "testImage.png",
  multimediaPath: NEUMOMED_IMAGE,
  name: "test Image",
  type: "imagen"
};

export const NOTIFICATION_MESSAGES_BODY = {
  TEXT_URL: "siguiente enlace"
};

export const VALID_IMG_EXTENSIONS = ["png", "jpeg", "jpg", "gif"];

export const WHATSAPP_DOCUMENT_CATEGORY = "DOCUMENTOS";
